import { useQuery } from '@apollo/client';
import {
  WttpQuestionnairesDocument,
  WttpQuestionnairesListFilterInput,
  WttpQuestionnairesQuery,
} from 'src/graphql/generated/graphql';

export const useQuestionnaires = ({
  filter,
  page,
  paginationLimit,
  onCompleted,
}: {
  filter?: WttpQuestionnairesListFilterInput;
  page: number;
  paginationLimit: number;
  onCompleted?: (data: WttpQuestionnairesQuery) => void;
}) => {
  const { data, loading } = useQuery<WttpQuestionnairesQuery>(
    WttpQuestionnairesDocument,
    {
      variables: {
        filter: filter,
        sorting: {},
        pagination: {
          limit: paginationLimit,
          offset: page * paginationLimit,
        },
      },
      onCompleted: onCompleted,
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-only',
    },
  );

  return {
    data: data?.wttpQuestionnaires,
    loading,
  };
};
